const Footer = () => (
  <footer className="bg-light p-2 text-center">
    <p>
      Sample app demonstrating NXP SSO integration
    </p>
  </footer>
)

export default Footer
